import React from 'react';
import { Popover, Box, IconButton, Tooltip, Divider, Menu, MenuItem } from '@mui/material';
import AddCommentIcon from '@mui/icons-material/AddComment';
import EditIcon from '@mui/icons-material/Edit';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export interface SelectionToolbarProps {
  open: boolean;
  anchor: { x: number; y: number } | null;
  onClose: () => void;
  onAddComment: () => void;
  onAddRevision: () => void;
  onRephrase: (variant?: 'conservative' | 'standard' | 'aggressive') => void;
  onCopy?: () => void;
}

const SelectionToolbar: React.FC<SelectionToolbarProps> = ({
  open,
  anchor,
  onClose,
  onAddComment,
  onAddRevision,
  onRephrase,
  onCopy
}) => {
  const anchorPosition = anchor
    ? { top: Math.max(anchor.y - 48, 80), left: Math.max(anchor.x, 12) }
    : { top: 100, left: 100 };

  const [aiMenuAnchor, setAiMenuAnchor] = React.useState<null | HTMLElement>(null);
  const aiMenuOpen = Boolean(aiMenuAnchor);
  const openAiMenu = (e: React.MouseEvent<HTMLElement>) => setAiMenuAnchor(e.currentTarget);
  const closeAiMenu = () => setAiMenuAnchor(null);

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      PaperProps={{
        elevation: 6,
        sx: {
          px: 1,
          py: 0.5,
          borderRadius: 3,
          display: 'flex',
          alignItems: 'center',
          gap: 0.5
        }
      }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title="Přidat poznámku (C)">
          <IconButton size="small" onClick={() => { onAddComment(); onClose(); }}>
            <AddCommentIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Divider flexItem orientation="vertical" sx={{ mx: 0.5 }} />
        <Tooltip title="Navrhnout revizi (R)">
          <IconButton size="small" onClick={() => { onAddRevision(); onClose(); }}>
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Divider flexItem orientation="vertical" sx={{ mx: 0.5 }} />
        <Tooltip title="Přeformulovat vybraný text (P)">
          <IconButton size="small" onClick={openAiMenu}>
            <AutoFixHighIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={aiMenuAnchor}
          open={aiMenuOpen}
          onClose={closeAiMenu}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
          <MenuItem onClick={() => { onRephrase('conservative'); closeAiMenu(); onClose(); }}>
            Konzervativní návrh
          </MenuItem>
          <MenuItem onClick={() => { onRephrase('standard'); closeAiMenu(); onClose(); }}>
            Standardní návrh
          </MenuItem>
          <MenuItem onClick={() => { onRephrase('aggressive'); closeAiMenu(); onClose(); }}>
            Agresivní návrh
          </MenuItem>
        </Menu>
        {onCopy && (
          <>
            <Divider flexItem orientation="vertical" sx={{ mx: 0.5 }} />
            <Tooltip title="Zkopírovat výběr (Ctrl+C)">
              <IconButton size="small" onClick={() => { onCopy(); onClose(); }}>
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </>
        )}
      </Box>
    </Popover>
  );
};

export default SelectionToolbar;
